export default defineAppConfig({
  ui: {
    colors: {
      /** Default platform chrome; tenant sites override at runtime via `applyAppConfigTheme`. */
      primary: 'blue',
      /** Dark-mode surfaces / text / borders for Nuxt UI neutral tokens. */
      neutral: 'slate',
    },
  },
  icon: {
    mode: 'svg',
    cssLayer: 'base',
  },
})
